import React, { useEffect, useState } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { v4 as uuidv4 } from 'uuid'
import { useNavigate } from 'react-router-dom'

import { ApplicationState } from '@store/types'
import { Page } from '@templates'
import { Camera } from '@interco/cp-react-ui-lib'
import routesV2 from '@routes/routes'
import { useWindowSize } from '@hooks'
import { setHideFooter, setHideHeader } from '@store/ui/navigation/actions'
import {
  sendToS3Contracheque,
  setAnexosContracheque,
  setIsErrorContracheque,
  setIsLoadingContracheque,
  setRollbackRouterErrorContracheque,
} from '@store/refinanciamento/contrachequeDocumentos/actions'
import { ReviewFoto } from '@organisms'
import { trackingRefin } from '@store/refinanciamento/simulacao/actions'
import { StepRefin } from '@utils/enums'
import Tag from '@utils/Tag'

const Foto = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [habilitaCamera, setHabilitaCamera] = useState(true)
  const [foto, setFoto] = useState('')
  const [fullScreenMobile, setFullScreenMobile] = useState(false)

  const { anexos, isLoading, isDone } = useSelector(
    (state: ApplicationState) => state.refinanciamento.contrachequeDocumentos,
  )
  const { convenioCodigo } = useSelector(
    (state: ApplicationState) => state.refinanciamento.contratos,
  )

  const size = useWindowSize()

  useEffect(() => {
    if (size.width < 680) {
      setFullScreenMobile(true)
    } else {
      setFullScreenMobile(false)
    }
    return () => {
      setFullScreenMobile(false)
    }
  }, [size])

  const { isApp } = useSelector((state: ApplicationState) => state.ui.navigation)

  const onConfirmReview = (fotografia: string) => {
    dispatch(trackingRefin(StepRefin.CLICK_FOTO_CONTRACHEQUE_USAR_FOTO))
    if (isApp) {
      Tag.enviarTagueamentoApp({
        screen: 'clt:refin:selfie',
        ref_type: '',
        content_action: 'Dado carregado',
        action_id: 'Usar esta',
        section: 'selfie',
        sub_section: 'photo',
        step: '',
        scenario: 'usar esta',
        ref_figma: '2',
      })
    } else {
      Tag.enviarTagueamentoWeb({
        element_action: 'click button',
        element_name: 'Usar esta',
        c_page: window.location.href,
        redirect_url: '',
        section_name: 'payrollloan:refin:selfie',
        section: 'selfie',
        sub_section: 'photo',
        step: '',
        scenario: 'usar esta',
      })
    }

    if (anexos.length === 1) {
      dispatch(setIsLoadingContracheque(true))
      dispatch(setIsErrorContracheque(false))
      dispatch(setRollbackRouterErrorContracheque(routesV2.STATUS_DOCUMENTO))
      dispatch(sendToS3Contracheque({ tipo: 'CONTRACHEQUE', anexos }))
    } else {
      const img = new Image()
      img.onload = () => {
        dispatch(
          setAnexosContracheque({
            anexo: {
              id: uuidv4(),
              nome: `CONTRACHEQUE.jpeg`,
              tipoExtensao: 'jpeg',
              blobs: [
                {
                  height: img.height,
                  width: img.width,
                  data: fotografia,
                },
              ],
            },
            tipo: 'CONTRACHEQUE',
          }),
        )

        if (anexos.length === 1) {
          dispatch(setIsLoadingContracheque(true))
          dispatch(setIsErrorContracheque(false))
          dispatch(setRollbackRouterErrorContracheque(routesV2.STATUS_DOCUMENTO))
          dispatch(sendToS3Contracheque({ tipo: 'CONTRACHEQUE', anexos }))
        }
      }

      img.src = fotografia
    }
  }

  useEffect(() => {
    if (isDone) {
      navigate(routesV2.STATUS_DOCUMENTO)
    }
  }, [navigate, convenioCodigo, isDone])

  useEffect(() => {
    if (isApp || fullScreenMobile) {
      dispatch(setHideFooter(true))
      dispatch(setHideHeader(true))
    } else {
      dispatch(setHideFooter(false))
      dispatch(setHideHeader(false))
    }
  }, [dispatch, fullScreenMobile, isApp])

  return habilitaCamera ? (
    <Page>
      <Camera
        audio={false}
        mask="secondary"
        mode="photo"
        facing="back"
        mobile={isApp || fullScreenMobile}
        onCapturedPhoto={(fotografia) => {
          setHabilitaCamera(false)
          setFoto(String(fotografia))
        }}
        titleDescription="Frente do Contracheque"
      />
    </Page>
  ) : (
    <ReviewFoto
      fotografia={foto}
      onConfirm={onConfirmReview}
      setHabilitaCamera={() => {
        setHabilitaCamera(true)
      }}
      isLoading={isLoading}
      forceIsMobile={fullScreenMobile}
    />
  )
}

export default Foto
